import { render, staticRenderFns } from "./priceListLottery.vue?vue&type=template&id=30b5cbd8&"
import script from "./priceListLottery.vue?vue&type=script&lang=js&"
export * from "./priceListLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports